import styled from '@emotion/styled';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React from 'react';
import data from '../../utils/dbSchema';
import Layout from '../Layout';
import { Wrapper } from '../UI';
import PageTitle from '../Layout/PageTitle'
import { Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import ShareIcon from '@material-ui/icons/Share';
import { Box } from '../UI';
import './style.css';

export default function MyProcesses() {
	const classes = useStyles();
	const headers = ['NDA', 'Summary', 'Letter of Intent', 'Due Dilligence'];
	const properties = data.properties;

	return (
		<Layout>
			<Wrapper pt="30px">
				<PageTitle title='My Processes'>
					<Box>
						<Button variant="contained" color="default" startIcon={<GetAppIcon />} className={classes.button}>
							Export
						</Button>
						<Button variant="contained" color="default" startIcon={<ShareIcon />} className={classes.button}>
							Share
						</Button>
						<Button variant="contained" color="default" startIcon={<PrintIcon />} className={classes.button}>
							Print
						</Button>
					</Box>
				</PageTitle>
				<TableContainer component={Paper}>
					<Table className={classes.table} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell>Property ID</TableCell>
								{headers.map(header => (
									<TableCell key={header} align="right" style={{textAlign: 'center'}}>
										<strong>{header.toUpperCase()}</strong>
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{properties.map(property => (
								<TableRow key={property.id} className={classes.cell}>
									<TableCell component="th" scope="row" className={classes.cell}>
										{property.id}
									</TableCell>
									<TableCell align="right" className={classes.cell} style={{textAlign: 'center'}}>
										{property.processes.nda ? <Tick /> : <CancelIcon color="error" />}
									</TableCell>
									<TableCell align="right" className={classes.cell} style={{textAlign: 'center'}}>
										{property.processes.summary ? <Tick /> : <CancelIcon color="error" />}
									</TableCell>
									<TableCell align="right" className={classes.cell} style={{textAlign: 'center'}}>
										{property.processes.loi ? <Tick /> : <CancelIcon color="error" />}
									</TableCell>
									<TableCell align="right" className={classes.cell} style={{textAlign: 'center'}}>
										{property.processes.dd ? <Tick /> : <CancelIcon color="error" />}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Wrapper>
		</Layout>
	);
}

const useStyles = makeStyles({
	table: {
		width: '100%',
	},
	cell: {
		width: '100px',
	},
	button: {
		marginLeft: '1rem'
	}
});

const Tick = styled(CheckCircleIcon)`
	color: #4caf50;
`;
